import { format, isValid, parse } from "date-fns";

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

export function dateToRFC3339(value: string | undefined): string | undefined {
	const trimmed = value?.trim() ?? "";
	if (!DATE_ONLY.test(trimmed)) return undefined;
	return `${trimmed}T00:00:00Z`;
}

export function dateOnlyToDate(value: string | undefined): Date | undefined {
	const trimmed = value?.trim() ?? "";
	if (!DATE_ONLY.test(trimmed)) return undefined;
	const parsed = parse(trimmed, "yyyy-MM-dd", new Date());
	return isValid(parsed) ? parsed : undefined;
}

export function dateToDateOnly(date: Date | undefined): string {
	return date ? format(date, "yyyy-MM-dd") : "";
}

const WORK_TIME_ZONE = "America/Sao_Paulo";

const workDateFormatter = new Intl.DateTimeFormat("en-CA", {
	timeZone: WORK_TIME_ZONE,
	year: "numeric",
	month: "2-digit",
	day: "2-digit",
});

export function currentWorkDate(): string {
	return workDateFormatter.format(new Date());
}

export function currentWorkDay(): Date {
	return parse(currentWorkDate(), "yyyy-MM-dd", new Date());
}
